module.exports = __webpack_public_path__ + "static/profilepic-dd14756b3cf25fe0204e3b3cdb7c2e8a.jpg";